const mutations = {
  setModels(state, data) {
    state.docenteEspacios = data.items;
    state.pagination = data._meta;
  },

  setModel(state, data) {
    state.docenteEspacio = data;
  },

  addModel(state, model) {
    state.record.nuevo = true;
    state.docenteEspacios.unshift(model);
  },

  updateModel(state, model) {
    state.model = model;
    state.record.actualizado = true;
  },

  delModel(state, id) {
    const removeIndex = state.docenteEspacios
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.docenteEspacios.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};
export default mutations;
